import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExportShareSheetComponent } from '../helper/components/export-share-sheet/export-share-sheet.component';
import { ModalService } from './modal.service';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import * as XLSX from 'xlsx';
import { TranslateService } from '@ngx-translate/core';
import { ActionSheetController } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
import { AndroidPermissionService, PermissionType } from './android-permission.service';
// import JSPDF from 'jspdf';
// import domtoimage from 'dom-to-image';

@Injectable({
  providedIn: 'root'
})
export class ShareExportService {

  constructor(private modalService: ModalService, private translateService: TranslateService,
    private actionSheetController: ActionSheetController, private androidPermissionService: AndroidPermissionService) { }


  openAddMediaSheet() {
    return new Observable(observer => {
      this.modalService.presentModal({
        component: ExportShareSheetComponent,
        componentProps: {},
        options: ModalService.defaultOptionsTransparent,
      }).then(response => {
        response.modalObj.onDidDismiss().then(dismiss => {
          if (dismiss.role === 'itemSelected') {
            observer.next(dismiss.data.key);
            observer.complete()
          } else {
            observer.next();
            observer.complete()
          }
        }).catch(err => {
          observer.error(err)
          observer.complete()
        })
      }).catch(err => {
        observer.error(err)
        observer.complete()
      });
    });
  }

  excelExport(exportData: Array<any>, fileName: string, title: string = "Title", dialogTitle: string = "Dialog Title") {

    let sheet = XLSX.utils.json_to_sheet(exportData);
    let wb = {
      SheetNames: ["export"],
      Sheets: {
        "export": sheet
      }
    };

    let wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: false,
      type: 'base64'
    });
    this.exportFile(fileName, wbout, title, dialogTitle, Directory.Library);
  }

  excelShare(exportData: Array<any>, fileName: string, title: string = "Title", dialogTitle: string = "Dialog Title") {

    let sheet = XLSX.utils.json_to_sheet(exportData);
    let wb = {
      SheetNames: ["export"],
      Sheets: {
        "export": sheet
      }
    };

    let wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: false,
      type: 'base64'
    });
    this.shareFile(fileName, wbout, title, dialogTitle, Directory.External);
  }

  exportFile(fileName, wbout, title, dialogTitle, directory) {
    try {
      this.androidPermissionService.requestPermisson(PermissionType.Storage).subscribe(per => {
        if (per) {
          Filesystem.writeFile({
            path: fileName,
            data: wbout,
            directory: directory
          }).then((writeFileResult) => {
            Filesystem.getUri({
              directory: directory,
              path: fileName
            }).then((getUriResult) => {
              // let shareRet = Share.share({
              //   title: title,
              //   url: getUriResult.uri,
              //   dialogTitle: dialogTitle
              // });
            }, (error) => {
              console.log(error);
            });
          });
        }
      })

    } catch (error) {
      console.error('Unable to write file', error);
    }
  }

  shareFile(fileName, wbout, title, dialogTitle, directory) {
    try {
      this.androidPermissionService.requestPermisson(PermissionType.Storage).subscribe(per => {
        if (per) {
          Filesystem.writeFile({
            path: fileName,
            data: wbout,
            directory: directory
          }).then((writeFileResult) => {
            Filesystem.getUri({
              directory: directory,
              path: fileName
            }).then((getUriResult) => {
              let shareRet = Share.share({
                title: title,
                url: getUriResult.uri,
                dialogTitle: dialogTitle
              });
            }, (error) => {
              console.log(error);
            });
          });
        }
      });
    } catch (error) {
      console.error('Unable to write file', error);
    }
  }
  async GetMapTypes(lat, lng) {
    let maps = [];
    let google = "https://www.google.com/maps/search/?api=1&query=" + lng + "," + lat;
    let yandex = "https://yandex.com.tr/harita/" + "?l=sat&z=17&whatshere[point]=" + lat + "," + lng + "&whatshere[zoom]=17";
    let apple = "maps://?q=" + lng + ',' + lat;
    if (Capacitor.getPlatform() == 'ios') {
      maps.push({
        text: this.translateService.instant("general.apple-maps"),
        role: "apple-maps",
        handler: (ev) => {
          window.open(apple, '_system');
          ev.modal.dismiss().then()
        }
      });
    }
    maps.push({
      text: this.translateService.instant("general.google-maps"),
      role: "google-maps",
      handler: (ev) => {
        window.open(google, '_system');
        ev.modal.dismiss().then()
      }
    });
    maps.push({
      text: this.translateService.instant("general.yandex-maps"),
      role: "yandex-maps",
      handler: (ev) => {
        window.open(yandex, '_system');
        ev.modal.dismiss().then()
      }
    });
    let action = await this.actionSheetController.create({
      cssClass: 'contact-sheet-style',
      buttons: maps,
    });

    await action.present();
  }

  share(shareOptions: any): Observable<boolean> {
    return new Observable(observer => {
      Share.share({
        title: shareOptions.Title,
        text: shareOptions.Text,
        url: shareOptions.Url,
        dialogTitle: shareOptions.DialogTitle
      }).then(res => {
        observer.next(true);
        observer.complete();
      }).catch(err => {
        observer.error(err);
        observer.complete();
      });
    });
  }
  // pdfExport(id: string) {
  //   const pdfBlock = document.getElementById(id);
  //   console.log("pdf",pdfBlock)
  //   const options = {
  //     background: "white",
  //     height: pdfBlock.clientWidth,
  //     width: pdfBlock.clientHeight
  //   };
  //   domtoimage.toPng(pdfBlock, options).then((fileUrl) => {
  //     var doc = new JSPDF("l", "px", "a4");
  //     doc.addImage(fileUrl, 'PNG', 10, 10, 1000, 1000);

  //     let docRes = doc.output();
  //     let buffer = new ArrayBuffer(docRes.length);
  //     let array = new Uint8Array(buffer);
  //     for (var i = 0; i < docRes.length; i++) {
  //       array[i] = docRes.charCodeAt(i);
  //     }
  //     var b64 = this.ToBase64(array);
  //     const fileName = "user-data.pdf";
  //     // Filesystem.appendFile({
  //     //   data:buffer.toString(),path:fileName,directory:Directory.Documents}).then(e=>{
  //       this.shareFile(fileName,b64, "", "",Directory.Cache);
  //     })
  //   // })
  // }

  // ToBase64 = function (u8) {
  //   return btoa(String.fromCharCode.apply(null, u8));
  // }
}
